import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import * as React from 'react';
import { programsStore } from '../../../ProgramsStore';
import { upcomingProgramResource, visibleProgramResource } from '../../../ProgramsStore/Functions';
import ProgramDashboards from '../ProgramDashboard/ProgramDashboards';
import NoProgramsInTab from '../ProgramTabs/NoProgramsInTab';
import * as style from '../style.module.css';

const UpcomingPrograms: React.FC<{}> = () => {
  return (
    <div className={style.active} data-test-upcoming-programs={true}>
      {programsStore.resource
        .map(({ payload }) =>
          payload.programs.filter(upcomingProgramResource).filter(visibleProgramResource),
        )
        .andThen(fromArrayMaybe)
        .map((upcomingPrograms) => <ProgramDashboards programs={upcomingPrograms} />)
        .getOrElse(() => (
          <NoProgramsInTab kind="You have no upcoming programs" />
        ))}
    </div>
  );
};

export default observer(UpcomingPrograms);
